import { useState, useEffect } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideBusinessAbstract } from './types'
import { BusinessIdeaUserEvaluationType } from '../../../../enums/BusinessIdeaUserEvaluation'

export const useBusinessAbstractDetail = (businessIdeaId: string) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [businessAbstract, setBusinessAbstract] = useState<SlideBusinessAbstract | null>(null)
  const [userEvaluation, setUserEvaluation] = useState<BusinessIdeaUserEvaluationType | null>(null)
  const [isBusinessAbstractLoading, setIsBusinessAbstractLoading] = useState(true)

  useEffect(() => {
    const businessAbstractDetail = async () => {
      if (!businessIdeaId) return

      setIsBusinessAbstractLoading(true)

      try {
        const response = await apiClient.business.slideAbstractDetailList(businessIdeaId)
        setBusinessAbstract(response.data.businessAbstract)
        setUserEvaluation(response.data.userEvaluation as BusinessIdeaUserEvaluationType | null)
      } catch (e) {
        console.error('事業詳細の取得に失敗しました:', e)
        handleError(e as ApiErrorResponse, showSnackBar)
        setBusinessAbstract(null)
        setUserEvaluation(null)
      } finally {
        setIsBusinessAbstractLoading(false)
      }
    }

    businessAbstractDetail()
  }, [businessIdeaId])

  return {
    businessAbstract,
    setBusinessAbstract,
    userEvaluation,
    setUserEvaluation,
    isBusinessAbstractLoading,
    setIsBusinessAbstractLoading,
  }
}
